import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"

const useGetMyEventList = () => {
    const [fetchResult, fetchRequest] = useFetch()
    const [searchParams] = useSearchParams()
    const page = searchParams.get("page")
    const search = searchParams.get("search")

    useEffect(() => {
        let path = `/admin/event/my/list?page=${page}`
        if (search) path += `&search=${search}`
        fetchRequest("GET", path)
    }, [page, search])

    return [fetchResult]
}

export default useGetMyEventList